module.exports = "0.32.0";



//////////////////
// WEBPACK FOOTER
// ./node_modules/autocomplete.js/version.js
// module id = 298
// module chunks = 0